(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seed-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class SeedHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-seed-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-seed-hero-dot]'));
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.interval = Number(this.dataset.interval) || 6000;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.slideIndex) || 0);
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      this.index = (nextIndex + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === this.index);
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    next() {
      this.show(this.index + 1);
    }

    start() {
      if (!this.autoplay || this.slides.length < 2) return;
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }
  }

  if (!customElements.get('seed-hero-slider')) {
    customElements.define('seed-hero-slider', SeedHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedshop-logo-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seedshop-logo-carousel')) {
    customElements.define('seedshop-logo-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.viewport = this.querySelector('.seedshop-logo-strip__inner');
        this.track = this.querySelector('.seedshop-logo-strip__track');
        this.group = this.track.firstElementChild;
        this.position = 0;
        this.drag = null;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.measure = () => {
          this.track.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
          this.width = this.group.getBoundingClientRect().width;
          if (!this.width) return;
          const count = Math.ceil(this.viewport.clientWidth / this.width) + 2;
          for (let i = 0; i < count; i++) {
            const copy = this.group.cloneNode(true);
            copy.dataset.copy = '';
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a').forEach(link => link.tabIndex = -1);
            copy.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
            if (i === 0) this.track.prepend(copy);
            else this.track.append(copy);
          }
          this.paint();
        };
        this.paint = () => {
          if (!this.width) return;
          this.position = ((this.position % this.width) + this.width) % this.width;
          this.track.style.transform = 'translate3d(' + (-this.width - this.position) + 'px,0,0)';
        };
        this.viewport.addEventListener('pointerdown', event => {
          if (event.button !== 0) return;
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, position: this.position, moved: false };
        }, options);
        this.viewport.addEventListener('pointermove', event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          const dx = event.clientX - this.drag.x;
          const dy = event.clientY - this.drag.y;
          if (!this.drag.moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(dy)) {
            this.drag.moved = true;
            this.viewport.setPointerCapture(event.pointerId);
            this.viewport.dataset.dragging = '';
          }
          if (this.drag.moved) {
            this.position = this.drag.position - dx;
            this.paint();
          }
        }, options);
        const release = event => {
          if (!this.drag || event.pointerId !== this.drag.id) return;
          this.suppressClick = this.drag.moved;
          this.drag = null;
          delete this.viewport.dataset.dragging;
          if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
          clearTimeout(this.clickTimer);
          this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 0);
        };
        window.addEventListener('pointerup', release, options);
        window.addEventListener('pointercancel', release, options);
        this.viewport.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); }
        }, { ...options, capture: true });
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
        this.observer = new ResizeObserver(this.measure);
        this.observer.observe(this.viewport);
        this.group.querySelectorAll('img').forEach(image => image.addEventListener('load', this.measure, options));
        this.measure();
        const tick = time => {
          const elapsed = Math.min((time - (this.lastTime || time)) / 1000, 0.05);
          this.lastTime = time;
          if (this.width && !this.drag && !this.reduced.matches && !document.hidden && !this.viewport.contains(document.activeElement)) {
            const duration = parseFloat(getComputedStyle(this).getPropertyValue('--seedshop-logo-strip-speed')) || 34;
            this.position += this.width / duration * elapsed;
            this.paint();
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.clickTimer);
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
